module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "PrivacyPolicy.47daa0e3.pdf";